// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h4[data-v-798a1b0b]{font-weight:500;margin-top:2rem}", "",{"version":3,"sources":["webpack://./resources/js/components/pages/CookiePolicy.vue"],"names":[],"mappings":"AACA,oBACI,eAAA,CACA,eAAJ","sourcesContent":["\nh4 {\n    font-weight: 500;\n    margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
